
import { usePatientStore } from '@/store/patient';
import { useRequestDataStore } from '@/store/request-data';
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import LangSwitch from './LangSwitch.vue';

export default defineComponent({
    components: { LangSwitch },

    setup()
    {
        const i18n = useI18n();
        const router = useRouter();

        function startNewPatient()
        {
            if (!confirm(i18n.t('general.areYouSureToLeave'))) {
                return;
            }

            // Clear stores so we start with a fresh patient
            usePatientStore().$reset();
            useRequestDataStore().deselectDrug();

            // Back to the 1st page
            router.push("/app");
        }

        function backToHome()
        {
            if (confirm(i18n.t('general.areYouSureToLeave'))) {
                router.push("/");
            }
        }

        return {
            startNewPatient,
            backToHome,
        };
    }
})
